import React, { useEffect, useState } from "react";

export default function AlertToast({
  message,
  type = "info", // success | error | warning | info
  duration = 4000,
  onClose,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;

    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onClose?.(), 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  const styles = {
    success: {
      background: "linear-gradient(180deg, #065f46, #047857)",
      border: "#10b981",
      icon: "✓",
    },
    error: {
      background: "linear-gradient(180deg, #7f1d1d, #b91c1c)",
      border: "#ef4444",
      icon: "✕",
    },
    warning: {
      background: "linear-gradient(180deg, #78350f, #b45309)",
      border: "#f59e0b",
      icon: "⚠",
    },
    info: {
      background: "linear-gradient(180deg, #1e3a8a, #2563eb)",
      border: "#3b82f6",
      icon: "ℹ",
    },
  };

  const s = styles[type] || styles.info;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        left: "50%",
        transform: `translateX(-50%) translateY(${visible ? "0" : "20px"})`,
        opacity: visible ? 1 : 0,

        background: s.background,

        color: "white",

        padding: "12px 20px",

        borderRadius: 12,

        border: `1px solid ${s.border}`,

        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",

        display: "flex",
        alignItems: "center",
        gap: 12,

        fontSize: 14,
        fontWeight: 500,

        zIndex: 9999,

        transition: "all 0.3s ease",

        minWidth: 280,
        maxWidth: 500,
      }}
    >
      <span style={{ fontWeight: "bold", fontSize: 18 }}>
        {s.icon}
      </span>

      <span style={{ flex: 1 }}>
        {message}
      </span>

      <button
        onClick={() => {
          setVisible(false);
          setTimeout(() => onClose?.(), 300);
        }}
        style={{
          background: "transparent",
          border: "none",
          color: "white",
          cursor: "pointer",
          fontSize: 16,
          opacity: 0.8,
        }}
      >
        ×
      </button>
    </div>
  );
}